/**
 * Utilitaire de wording dynamique selon le vendorType de la société
 *
 * Garant (1) → "Garantie", "Garanties", "contrat de garantie"
 * Prestataire (2) → "Prestation", "Prestations", "contrat de prestation"
 * Both (3) / défaut → "Garantie" (par défaut)
 */

import { VENDOR_TYPES } from '../features/societies/types/society.types';

export interface VendorWording {
  /** "Garantie" ou "Prestation" */
  singular: string;
  /** "Garanties" ou "Prestations" */
  plural: string;
  /** "garantie" ou "prestation" (minuscule) */
  singularLower: string;
  /** "garanties" ou "prestations" (minuscule) */
  pluralLower: string;
  /** "la garantie" ou "la prestation" */
  withArticle: string;
  /** "une garantie" ou "une prestation" */
  withIndefinite: string;
  /** "de garantie" ou "de prestation" */
  deType: string;
  /** "des garanties" ou "des prestations" */
  desPlural: string;
  /** "contrat de garantie" ou "contrat de prestation" */
  contrat: string;
}

const GARANTIE_WORDING: VendorWording = {
  singular: 'Garantie',
  plural: 'Garanties',
  singularLower: 'garantie',
  pluralLower: 'garanties',
  withArticle: 'la garantie',
  withIndefinite: 'une garantie',
  deType: 'de garantie',
  desPlural: 'des garanties',
  contrat: 'contrat de garantie',
};

const PRESTATION_WORDING: VendorWording = {
  singular: 'Prestation',
  plural: 'Prestations',
  singularLower: 'prestation',
  pluralLower: 'prestations',
  withArticle: 'la prestation',
  withIndefinite: 'une prestation',
  deType: 'de prestation',
  desPlural: 'des prestations',
  contrat: 'contrat de prestation',
};

/**
 * Retourne le wording adapté au vendorType
 * @param vendorType 1=Garant, 2=Prestataire, 3=Both
 */
export function getVendorWording(vendorType: number | undefined | null): VendorWording {
  if (vendorType === VENDOR_TYPES.PRESTATAIRE) {
    return PRESTATION_WORDING;
  }
  return GARANTIE_WORDING;
}

/**
 * Retourne le wording adapté au warrantyType (pour le wizard de création de garantie/prestation)
 * @param warrantyType 0=WARRANTY (Garantie), 1=SERVICE (Prestation)
 */
export function getWarrantyTypeWording(warrantyType: number | undefined | null): VendorWording {
  if (warrantyType === 1) {
    return PRESTATION_WORDING;
  }
  return GARANTIE_WORDING;
}
